import React, { useState, useEffect, useRef } from 'react';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import config from '../../config';

const VerifyEmail = ({ token, onSuccess }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [userData, setUserData] = useState(null);
  const verificationAttempted = useRef(false);

  useEffect(() => {
    const verifyEmail = async () => {
      // Protection contre les doubles appels (React StrictMode)
      if (verificationAttempted.current) {
        return;
      }
      verificationAttempted.current = true;

      try {
        const response = await fetch(`${config.API_URL}/api/auth/verify-email/${token}`);
        const data = await response.json();

        if (!response.ok) {
          setError(data.error || 'Erreur lors de la vérification');
          setLoading(false);
          return;
        }

        setSuccess(true);
        setUserData(data.user);

        // Stocker le token pour connexion automatique
        if (data.token) {
          localStorage.setItem('kokpeet_token', data.token);
        }

        // Rediriger après 3 secondes
        if (onSuccess) {
          setTimeout(() => onSuccess(data.user, data.token), 3000);
        }
      } catch (err) {
        console.error('Erreur vérification email:', err);
        setError('Erreur de connexion au serveur');
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      verifyEmail();
    } else {
      setError('Token de vérification manquant');
      setLoading(false);
    }
  }, [token, onSuccess]);

  if (loading) {
    return (
      <div className="verify-email-loading">
        <Loader2 size={48} className="spin" />
        <h3>Vérification en cours...</h3>
        <p>Veuillez patienter pendant que nous vérifions votre email.</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="verify-email-error">
        <div className="error-icon">
          <XCircle size={48} />
        </div>
        <h3>Erreur de vérification</h3>
        <p>{error}</p>
        <p className="help-text">
          Si le problème persiste, vous pouvez demander un nouveau lien de vérification depuis la page de connexion.
        </p>
      </div>
    );
  }

  if (success) {
    return (
      <div className="verify-email-success">
        <div className="success-icon">
          <CheckCircle size={48} />
        </div>
        <h3>Email vérifié avec succès !</h3>
        <p>
          Bienvenue sur Kokpit{userData?.name ? `, ${userData.name}` : ''} !
          <br /><br />
          Votre compte est maintenant actif. Vous allez être redirigé automatiquement...
        </p>
      </div>
    );
  }

  return null;
};

export default VerifyEmail;
